import { Box, CircularProgress, Typography } from "@mui/material";

export const GridLoadingOverlay = () => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, px: 1 }}>
    <CircularProgress size={22} />
    <Typography variant="body2">Loading Strand Losses...</Typography>
  </Box>
);
